import Papa from 'papaparse';

export const CSV_DELIMITER = ',';
export const TSV_DELIMITER = '\t';

export function parseCsvFile(file, delimiter = CSV_DELIMITER) {
  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      delimiter,
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        const { data, errors } = results;
        if (errors?.length > 0) {
          reject(errors);
        } else {
          resolve(data);
        }
      },
    });
  });
}
